<template>
  <div class="baogao-list">
    <div class="baogao-list-top">
      <div class="title" @click="showCalendar=true">请选择日期：</div>
      <div class="date" @click="showCalendar=true"><span>{{ date }}</span>
        <van-icon class="iconclass" name="play" />
      </div>
    </div>
    <van-calendar
      v-model="showCalendar"
      :min-date="minDate"
      :max-date="maxDate"
      :style="{ height: '70vh' }"
      type="range"
      :allow-same-day="true"
      color="#1989fa"
      @confirm="onConfirm"
    />
    <van-tabs v-model="activeName">
      <van-tab title="检查项目" name="1">
        <van-loading v-show="jcLoading" class="my-loading" type="spinner" color="#1989fa" />
        <van-cell-group v-show="jcList.length > 0 && !jcLoading" size="large">
          <van-cell
            v-for="item in jcList"
            :key="item.id"
            center
            :title="item.studyscripTion"
            :label="item.studyTime"
            is-link
            @click="toJcDetail(item)"
          />
        </van-cell-group>
        <noData v-show="jcList.length === 0 && !jcLoading" title="暂无检查报告" />
      </van-tab>
      <van-tab title="检验项目" name="2">
        <van-loading v-show="jyLoading" class="my-loading" type="spinner" color="#1989fa" />
        <van-cell-group v-show="jyList.length > 0 && !jyLoading" size="large">
          <van-cell
            v-for="item in jyList"
            :key="item.id"
            center
            :title="item.reqItems"
            :label="item.reqDate"
            is-link
            @click="toDetail(item)"
          />
        </van-cell-group>
        <noData v-show="jyList.length === 0 && !jyLoading" title="暂无检验报告" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'BaogaoList',
  data() {
    return {
      date: '',
      showCalendar: false,
      minDate: new Date('2020/1/1'),
      maxDate: new Date(),
      startDate: '',
      endDate: '',
      hisPatientId: '',
      id: '',
      jyLoading: false,
      jcLoading: false,
      jyFinished: false,
      jcFinished: false,
      activeName: '1',
      jcCurrent: 1,
      jyCurrent: 1,
      pageSize: 10,
      jcList: [],
      jyList: []
    }
  },
  computed: {
    userId() {
      return this.$store.state.userInfo.id
    }
  },

  activated() {
    if (this.$route.meta.from?.path === '/myPatient') {
      const startDate = moment().subtract(1, 'month').format('YYYY-MM-DD')
      const endDate = this.formatDate(new Date())
      this.date = `${startDate}~${endDate}`
      this.startDate = startDate
      this.endDate = endDate
      this.ageCreated()
    }
  },
  methods: {
    ageCreated() {
      this.id = this.$route.query.id
      this.blhNo = this.$route.query.blhNo
      this.getList()
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    onConfirm(date) {
      const [start, end] = date
      this.showCalendar = false
      this.date = `${this.formatDate(start)}/${this.formatDate(end)}`
      this.startDate = this.formatDate(start)
      this.endDate = this.formatDate(end)
      this.getList()
    },
    getList() {
      this.getInspectListPage()
      this.getInspectionListPage()
    },
    // 检查报告
    getInspectListPage() {
      this.jcLoading = true
      const obj = {
        blNo: this.blhNo,
        startDate: this.startDate,
        endDate: this.endDate,
        name: this.$route.query.patientName,
        patientID: this.$route.query.hisPatientId,
        userId: this.userId
      }
      this.jcList = []
      this.$Apis.getInspectReport(obj).then(res => {
        this.jcLoading = false
        if (res.code === 200) {
          this.jcList = res.data.result || []
          this.jcFinished = true
        } else {
          this.jcFinished = true
        }
      }).catch(() => {
        this.jcLoading = false
        this.jcFinished = true
      })
    },
    // 检验报告
    getInspectionListPage() {
      this.jyLoading = true
      const obj = {
        patientId: this.blhNo,
        startTime: this.startDate,
        endTime: this.endDate,
        userId: this.userId
      }
      this.jyList = []
      this.$Apis.getGjyyReportList(obj).then(res => {
        this.jyLoading = false
        if (res.code === 200) {
          this.jyList = res.data.reports || []
          this.jyFinished = true
        }
        this.jyFinished = true
      }).catch(() => {
        this.jyLoading = false
        this.jyFinished = true
      })
    },
    jcOnLoad() {
      this.jcCurrent++
      this.getInspectListPage()
    },
    jyOnLoad() {
      this.jyCurrent++
      this.getInspectionListPage()
    },
    toJcDetail(item) {
      this.$router.push(`/baogaoJcDetail?id=${item.pacsStudyuniqueid}`)
      localStorage.setItem('baogaoJcDetail', JSON.stringify(item))
    },
    toDetail(item) {
      localStorage.setItem('baogaoDetail', JSON.stringify(item))
      this.$router.push(`/baogaoDetail?reportNo=${item.reportID}&patientName=${this.$route.query.patientName}`)
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.baogao-list {
  margin: 0 .15rem;

  &-top {
    height: 1.25rem;
    background: url('../../assets/images/bg-top-bj.png') center center no-repeat;
    background-size: cover;
    padding: 0 0 0 .15rem;
    margin-bottom: .15rem;
    display: flex;
    flex-flow: column;
    justify-content: center;
    color: #FFFFFF;
    font-size: .18rem;

    .title {
      margin-bottom: .1rem;
    }

    .date {
      span {
        margin-right: .05rem;
      }

      .iconclass {
        transform: rotateZ(90deg);
      }
    }
  }

  :deep(.van-tabs__line) {
    background-color: #2B8CFF;
  }

  :deep(.van-tab--active) {
    color: #2B8CFF;
  }
}
</style>
